<template lang="pug">
.t-content
	section.info-sec
		.max-container
			.panelbox
				.panel-holder
					.resbox
						.resbox-con
							.resbox-cusbox.dp.aaa
								.resbox-tabs
									ul.nav.nav-tabs.s2(role='tablist')
										li.nav-item(role='presentation' @click="toProfile(0)")
											button#setProfile-tab.nav-link
												img(src='/images/menu/a-profile.png')
												span {{$t('ui.profile')}}
										//- li.nav-item(role='presentation' @click="changeTab(4)")
										li.nav-item
											button#setInbox-tab.nav-link.active
												img(src='/images/menu/a-history.png')
												span {{$t('ui.statement')}}
										li.nav-item(role='presentation' @click="$router.push('/inbox').catch(err => {})")
											button#setInbox-tab.nav-link(data-bs-toggle='tab' data-bs-target='#setInbox' type='button' role='tab' aria-controls='setInbox' aria-selected='true')
												img(src='/images/menu/a-inbox.png')
												span {{$t('ui.inbox')}}
										li.nav-item(v-if="$store.getters.transaction.length === 0" role='presentation' @click="toProfile(3)")
											button#setAddBank-tab.nav-link
												img(src='/images/menu/a-bank.png')
												span {{$t('ui.add_bank')}}
										li.nav-item(v-if="$store.getters.transaction.length > 0" role='presentation' @click="toProfile(1)")
											button#setBankDetail-tab.nav-link
												img(src='assets/img/bank/m-bank-d.png')
												span  {{$t('ui.bank_detail')}}
										li.nav-item(role='presentation' @click="toProfile(2)")
											button#setChangePassword-tab.nav-link
												img(src='/images/menu/a-password.png')
												span {{$t('ui.change_password')}}
									.tab-content
										.tab-pane.fade.show.active#setHistory(role="tabpanel" aria-labelledby="ppg-tab")
											.epw-nwrap.inbox-wrap
												.abtn-group
													a.abtn.epw-ntabs(href='javascript:void(0)' :class="{'active': selectedTab === 0}" @click="switchTab(0)") Daily Statement
													a.abtn.epw-ntabs(href='javascript:void(0)' :class="{'active': selectedTab === 1}" @click="switchTab(1)") Transaction History
												template(v-if="selectedTab === 0")
													.inboxcons.epw-ncons.active
														//- .historynote
														template(v-if="!this.showPlatformWinLose")
															.text-center.mb-2
																div(v-if="showReport")
																	span.pointer.text-decoration-underline(@click="clearReportType") {{$t('ui.statement')}} 
																	span > 
																	span.pointer {{reportType}}
															statement(@showBetHistory="showBetHistory" @reportSelected="reportSelected" ref="dailyStatement")
														template(v-else)
															.text-center.mb-2
																div
																	span.pointer.text-decoration-underline(@click="backToStatement") {{$t('ui.statement')}} 
																	span > 
																	span.pointer(@click="clearCategory" :class="{'text-decoration-underline': category!=''}") {{$t('ui.bet_history')}} 
																	span {{category}}
															platformWinLose(ref="platformWinLose" :platformData="platformData" @platformSelected="platformSelected")
												template(v-if="selectedTab === 1")
													transaction(@updateTrans="updateTrans")

</template>
<script>
import statement from "@/components2/_statement.vue"
import transaction from "@/components2/_history.vue"
import platformWinLose from "@/components2/_betHistory.vue"
export default {
  components:{
    statement,
    transaction,
    platformWinLose

  },
  data(){
		return{
			selectedTab: 0,
			transNo: 0,
			showPlatformWinLose: false,
			showReport: false,
			platformData: [],
			category: ""
		}		
	},
  computed: {
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
	watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        vm.$router.push("/").catch(err => {});
      }
    }
  },
  mounted(){
		window.scroll(0,0)
		var q = this.$route.query;
		if(!_.isEmpty(this.$route.params)){
      if(this.$route.params.checkTrans == true){
				this.selectedTab = 1
			}
    }
	},
  methods:{
		toProfile(target){
      this.$router.push({
        name:"profile",
        params:{
          "option": target
        }
      }).catch(error =>{})
    },
    switchTab(option){
			if(option == this.selectedTab){
				return;
			}else{
				this.selectedTab = option
			}
		},
    updateTrans(e){
			this.transNo = e
		},
		showBetHistory(e){
			this.showPlatformWinLose = true
			this.platformData = e.data
		},
		reportSelected(e){
			this.showReport = true
			switch(e){
				case 0:
					this.reportType = this.$t('ui.transfer')
					break;
				case 1:
					this.reportType = this.$t('ui.bonus_details')
					break;
				case 2:
					this.reportType = this.$t('ui.adjustment_details')
					break;
				case 3:
					this.reportType = this.$t('ui.referee')
				default:
					break;
			}
		},
		platformSelected(e){
			this.category = "> " + this.$t('ui.'+ e.toLowerCase())
		},
		clearReportType(){
			if(this.showReport === false && this.reportType === ""){
				return
			}else{
				this.showReport = false
				this.reportType = ""
				this.$refs.dailyStatement.reset()
			}
		},
		backToStatement(){
			if(this.showPlatformWinLose === false && this.category === ""){
				return
			}else{
				this.showPlatformWinLose = false
				this.category = ""
			}
		},
		clearCategory(){
			this.$refs.platformWinLose.reset()
			this.category = ""
		},
		reset(){
			this.category = ""
			this.reportType = ""
			this.showReport = false
			this.platformWinLose = false
		}
  }
}
</script>